/*
 * Login Messages
 *
 * This contains all the text for the Login component.
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
    header: {
        id: 'app.containers.Login.header',
        defaultMessage: 'This is Login container asds!',
    },
    forgetPassword: {
        id: 'app.containers.Login.forgetPassword',
        defaultMessage: 'Forgot password?',
    },
    notYetAMember: {
        id: 'app.containers.Login.notYetAMember',
        defaultMessage: 'Not a member yet?',
    },
});
